module.exports = __webpack_public_path__ + "media/images/links_to_banks_on_success_page/Techcombank-9f6db6182d4516cd04caa85dca71324d.png";